import get from 'lodash/get'

import { LOG_LEVELS } from '../constants/errors'
import endpoints, { Endpoint } from '../constants/endpoints'

const ajaxQuery = new XMLHttpRequest()

interface MapCreateLogPayloadError {
  name?: string
  type?: string
  message?: any
  stack: any
}
export interface MapCreateLogPayload {
  error: MapCreateLogPayloadError
  level?: string
}
export const mapCreateLog = (payload: MapCreateLogPayload) => {
  const appId = window.APP_ID
  const environment = window.ENVIRONMENT

  const error = get(payload, 'error')
  const level = get(payload, 'level')

  let name = JSON.stringify(error.name || '')

  if (error.type) {
    name = `${name} - ${JSON.stringify(error.type)}`
  }

  return {
    appId,
    level: level || LOG_LEVELS.ERROR,
    name,
    message: error.message ? JSON.stringify({ appId, message: error.message }) : '',
    stacktrace: JSON.stringify(error.stack),
    clientCreatedAt: new Date(),
    environment,
  }
}

export const createLog = (payload: MapCreateLogPayload) => {
  try {
    const endpoint: Endpoint = endpoints.openApi.createLog
    const mappedPayload = mapCreateLog(payload)
    ajaxQuery.open(endpoint.method, `${window.API_URL}${endpoint.url}`)
    ajaxQuery.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    ajaxQuery.setRequestHeader('X-Flow-Id', window.FLOW_ID)
    ajaxQuery.send(JSON.stringify(mappedPayload))
  } catch (ex) {
    window.console.log(ex)
  }
}

export default createLog
